import React, { Component } from "react";
import DepartmentIndustryCards from "../component/DepartmentIndustryCards";
import Banner from "../../../components/common/Banner";
import Header from "../../../components/common/Header";
import DepartmentSidebar from "../component/DepartmentSidebar";
import Footer from "../../../components/common/Footer";

export default class CyberIndustry extends Component {
  render() {
    return (
      <div>
        {/* Header */}
        <Header />

        {/* Banner */}
        <Banner
          title="CSE (IOT & Cyber Security Including Blockchain Technology)"
          image="banners/department-cse.jpg"
        />

        {/* Content */}
        <div className="sidebar ttm-sidebar ttm-bgcolor-white clearfix">
          <div className="container-xl">
            <div className="row">
              <div className="col-lg-9 content-area order-lg-2">
                <div className="ttm-service-single-content-area">
                  <div className="section-title with-desc text-left clearfix">
                    <div
                      className="title-header"
                      style={{ borderTopColor: "red" }}
                    >
                      <h4 className="title">Industry Interactions</h4>
                    </div>
                  </div>
                  <div className="ttm-service-description">
                    <p className="justify">
                      Presently there are 4 MOU's signed and associated with
                      CSE(ICB) Department. Workshops and Webinars are conducted
                      in every academic years.
                      <a
                        className="ttm-btn"
                        style={{ paddingLeft: "10px" }}
                        href="https://docs.google.com/spreadsheets/d/1z5dv00JBkef7Yibt7oFCezojK0W-E53-8p2l3sUtUus/edit?usp=sharing"
                        target="_blank"
                      >
                        Industry Interactions Link
                      </a>
                      <a
                        className="ttm-btn"
                        style={{ paddingLeft: "10px" }}
                        href="https://drive.google.com/drive/folders/1FNeCAKJsxG5BcnvevlCsJmaKsL8oGr_0?usp=sharing"
                        target="_blank"
                      >
                        MOU Agreements Copy
                      </a>
                    </p>
                    <div className="section-title with-desc text-left clearfix paddingtop-2">
                      <div
                        className="title-header"
                        style={{ borderTopColor: "red" }}
                      >
                        <h5> Internships With Industries</h5>
                      </div>
                    </div>
                    <p>
                      With the growing number of students opting for engineering
                      as a career over the past few decades, it has become
                      essential to equip them with skills that help them stand
                      out and excel in their chosen fields. Recognizing this
                      need, the All India Council for Technical Education
                      (AICTE) has made it mandatory for engineering
                      undergraduates to complete three internships, each lasting
                      4-8 weeks. This initiative aims to achieve several
                      objectives, with the foremost being to enhance students’
                      employability and prepare them for industry demands.
                    </p>
                    <div className="section-title with-desc text-left clearfix paddingtop-2">
                      <div
                        className="title-header"
                        style={{ borderTopColor: "red" }}
                      >
                        <h5>Why Internships with Industries is necessary?</h5>
                      </div>
                    </div>
                    <ul className="ttm-list ttm-list-style-icon">
                      <li>
                        <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          Practical Industry Exposure: Internships provide
                          students with real-world experience, allowing them to
                          apply theoretical knowledge in practical, professional
                          settings.
                        </span>
                      </li>
                      <li>
                        <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          Skill Development: They help students develop
                          essential technical, communication, teamwork, and
                          problem-solving skills required in the workplace
                        </span>
                      </li>
                      <li>
                        <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          Career Clarity and Networking: Internships help
                          students explore different career paths, understand
                          job roles, and build valuable professional connections
                          for future opportunities.
                        </span>
                      </li>
                      <li>
                        <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          Improved Employability: Having internship experience
                          makes students more competitive in the job market,
                          showcasing their ability to adapt and perform in real
                          work environments.
                        </span>
                      </li>
                    </ul>
                    <DepartmentIndustryCards department="cyber" />
                  </div>
                </div>
              </div>
              <div className="col-lg-3 widget-area">
                <DepartmentSidebar department="cyber" />
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <Footer />
      </div>
    );
  }
}
